import React from 'react';
import { Show, SimpleShowLayout, TextField, ImageField } from 'react-admin'

export const AnnounceShow = (props) => (
    <Show {...props}>
        <SimpleShowLayout>
            <TextField source="title" />
            <ImageField source="image.url" title="image.name" />
            <TextField source="description" />
        </SimpleShowLayout>
    </Show>
);


// WEBPACK FOOTER //
// ./src/components/announce/AnnounceShow.js